
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
// Image removed - use img tag;
import { Link } from "react-router-dom";
import { categoriesApi } from "@/lib/api";

interface Category {
  id: number;
  name: string;
  slug: string;
  description: string | null;
  image_url: string | null;
  icon: string | null;
  is_active: boolean;
  display_order: number;
}

export default function ShopByCategory() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await categoriesApi.getAll();
        const categoriesData = response.categories || [];
        setCategories(categoriesData);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading) {
  return (
    <section id="shop-by-category" className="py-16 bg-white mt-8 mb-4 scroll-mt-32">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold font-playfair text-center mb-12">
            Shop by Category
          </h2>
          <div className="flex flex-wrap justify-center gap-6">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="animate-pulse flex flex-col items-center">
                <div className="w-32 h-32 bg-gray-200 rounded-full mb-3" />
                <div className="h-4 bg-gray-200 rounded w-20" />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (categories.length === 0) {
    return null;
  }

  return (
    <section id="shop-by-category" className="py-16 bg-white mt-8 mb-4 scroll-mt-32">
      <div className="container mx-auto px-4">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-4xl font-bold font-playfair text-center mb-12"
        >
          Shop by Category
        </motion.h2>
        <div className="flex flex-wrap justify-center gap-8">
          {categories.map((category, index) => (
            <motion.div
              key={category.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="flex flex-col items-center"
            >
                <Link
                to={`/products?category=${category.slug}`}
                className="group block"
              >
                <div className="relative w-32 h-32 rounded-full overflow-hidden bg-gradient-to-br from-purple-50 to-pink-50 mb-3 shadow-sm hover:shadow-lg transition-all duration-300">
                  {category.image_url ? (
                    <img
                      src={category.image_url}
                      alt={category.name}
                      
                      className="object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      {category.icon ? (
                        <span className="text-4xl">{category.icon}</span>
                      ) : (
                        <span className="text-3xl font-bold text-purple-300">
                          {category.name.charAt(0)}
                        </span>
                      )}
                    </div>
                  )}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300" />
                </div>
                <h3 className="text-center text-sm font-semibold text-gray-900 group-hover:text-purple-600 transition-colors">
                  {category.name}
                </h3>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
